import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { LoadPolicyHolderReferenceDataClientResponse } from '../@types/LoadPolicyHolderReferenceData'

type Store = {
  policyHolderReferenceData: LoadPolicyHolderReferenceDataClientResponse | null
  setPolicyHolderReferenceData: (
    value: LoadPolicyHolderReferenceDataClientResponse,
  ) => void
}

export const useLoadPolicyHolderReferenceDataStore = create<Store>()(
  devtools(
    (set) => ({
      policyHolderReferenceData: null,
      setPolicyHolderReferenceData: (policyHolderReferenceData) =>
        set({ policyHolderReferenceData }),
    }),
    { name: 'LoadPolicyHolderReferenceDataStore' },
  ),
)
